module.exports = __webpack_public_path__ + "static/media/permanent-tsb.04c14fad.png";